import http from 'plugins/axios';

export default {

    pushChineseContent(data) {
        return http.post({
            url: '/admin/push/contentZh',
            data,
            dataType:'form'
        })
    },

    pushEnglishContent(data) {
        return http.post({
            url: '/admin/push/contentEn',
            data,
            dataType:'form'
        })
    },

    getQuotationPushConf(data) {
        return http.post({
            url: '/admin/quotation/message/listAll',
            data,
            dataType:'form'
        })
    },

    addQuotationPushConf(data) {
        return http.post({
            url: '/admin/quotation/message/add',
            data,
            dataType:'form'
        })
    },

    updateQuotationPushConf(data) {
        return http.post({
            url: '/admin/quotation/message/update',
            data,
            dataType:'form'
        })
    },

    removeQuotationPushConf(data) {
        return http.post({
            url: '/admin/quotation/message/delete',
            data,
            dataType:'form'
        })
    },

    updateActivatedById(data) {
        return http.post({
            url : '/admin/quotation/message/updateActivatedById',
            data,
            dataType:'form'
        })
    },

    savePushProviderType(data){
        return http.post({
            url : '/admin/push/providerSave',
            data,
            dataType:'form'
        })
    },

    queryPushProviderType(){
        return http.get({
            url : '/admin/push/providerQuery',
        })
    },

    queryPushSwitch(){
        return http.get({
            url : '/admin/push/switchQuery',
        })
    },

    savePushSwitch(data){
        return http.post({
            url : '/admin/push/switchSave',
            data,
            dataType:'form'
        })
    }
}